import React from 'react';
import styled from 'styled-components';
import { Typography } from 'antd';
import { ParagraphProps as AntdParagraphProps } from 'antd/lib/typography/Paragraph';

const { Paragraph: AntdParagraph } = Typography;

export interface ParagraphProps extends AntdParagraphProps {
  hideMargin?: boolean;
}

const StyledParagraph = styled(AntdParagraph)<{
  $hideMargin: ParagraphProps['hideMargin'];
}>`
  && {
    ${({ $hideMargin }) => $hideMargin && `margin: 0`};
  }
`;

export const Paragraph: React.FC<ParagraphProps> = ({
  hideMargin,
  ...props
}) => <StyledParagraph $hideMargin={hideMargin} {...props} />;

export default styled(Paragraph)``;
